const productListConfig = {
  barcodeLabelImage: false
};

export default productListConfig;